import avatarInput from './avatar-input'
import avatarCrop from './avatar-crop'
export {
  avatarInput,
  avatarCrop
}



// WEBPACK FOOTER //
// ./src/components/avatar-crop/index.js